import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { BusinessUnitService } from '../services/business-unit.service';
import { AuthService } from '../services/auth.service';

export const businessUnitSetupGuard: CanActivateFn = (_route, state) => {
  const buService = inject(BusinessUnitService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const onSetupPage = state.url.startsWith('/setup/business-unit');
  const canCreateBu = authService.isSuperAdmin() || authService.isTenantAdmin();

  return buService.checkExists().pipe(
    map(exists => {
      let decision: string;
      if (exists && onSetupPage) decision = 'redirect /home (exists, on setup page)';
      else if (!exists && !onSetupPage && canCreateBu) decision = 'redirect /setup/business-unit (no committees)';
      else decision = 'allow';
      // TEMP DIAGNOSTIC — remove once confirmed.
      console.debug('[setup-guard] business-unit', {
        url: state.url, exists, onSetupPage,
        isSuper: authService.isSuperAdmin(), isTenantAdmin: authService.isTenantAdmin(),
        canCreateBu, decision,
      });

      if (exists && onSetupPage) return router.createUrlTree(['/home']);
      if (!exists && !onSetupPage && canCreateBu) return router.createUrlTree(['/setup/business-unit']);
      return true;
    })
  );
};
